import { getChangedProperties } from "../../../helpers/dataManipulations";
import { FormsService } from "../../../services/forms/forms.service";
import { UpdatePromoCodeActionType } from "../types";

export function* updatePromoCodeSaga({ payload }: UpdatePromoCodeActionType) {
    try {
        const {
            data: { data },
        } = yield FormsService.updatePaymentPromoCode(
            getChangedProperties(payload.prevState, payload.currentState),
            payload.currentState._id!,
        );

        if (data && payload.index !== null) {
            payload.promoList[payload.index] = data;
            window.handleChange({ id: "payment.promocodes", value: payload.promoList });
        }
    } catch (error) {
        // yield put(Handle Error);
    }
}
